import categoriesProps from '../interfaces/CategoryProps';

const checkCategory = (categoriesList: Array<categoriesProps>, currentText: string) => {
  const category = categoriesList.find(categoryEl => categoryEl.category_name.toLowerCase().includes(currentText));
  return category ? category.category_name : null;
};

export default checkCategory;